import { useMemo } from 'react';
import { useBaseInputProps } from './baseInputProps';
import typesOfChoices from '../../../../constants/typesOfChoices';

/**
 *
 * @param { string } name - имя поля
 * @param { Object } data - Данные
 * @param { Object } fields - Поля
 * @param { Object } errors - Ошибки
 * @param { function } onChange - handler
 * @param { boolean } isReadOnly - isReadOnly
 * @param {string[]} readOnlyFelds - readOnlyFelds
 * @returns {{
 *  onChange: (function(*, *): *),
 *  description: string,
 *  readOnly: boolean,
 *  controlId: string,
 *  label: string,
 *  value: Object,
 *  required: boolean,
 *  errors: Array}}
 */

// eslint-disable-next-line max-len
export const useItemInputProps = (
  name,
  data,
  fields,
  errors,
  onChange,
  isReadOnly = false,
  readOnlyFelds = [],
) => {
  const baseProps = useBaseInputProps(
    name,
    data,
    fields,
    errors,
    onChange,
    isReadOnly,
    readOnlyFelds,
  );
  const backend = useMemo(
    () => (fields && fields[name] ? fields[name].resource : null),
    [fields, name],
  );
  const typeOfChoice = useMemo(
    () => {
      if (!fields || !fields[name] || !fields[name].selection_mode) return null;
      switch (fields[name].selection_mode) {
        case 'items':
          return typesOfChoices.onlyElements;
        case 'folders':
          return typesOfChoices.onlyGroups;
        case 'all':
          return typesOfChoices.groupsEndElements;
        default:
          return null;
      }
    },
    [fields, name],
  );
  return useMemo(
    () => ({
      ...baseProps,
      backend,
      ...(typeOfChoice !== null ? { typeOfChoice } : {}),
      canErase: !baseProps.required,
    }),
    [backend, baseProps, typeOfChoice],
  );
};

export default useItemInputProps;
